// extracted by mini-css-extract-plugin
module.exports = {"root":"TechnicalSpecifications_root__3YRRE","attributeName":"TechnicalSpecifications_attributeName__3CsQP"};